import { authRoutes } from '@services';
import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const api = axios.create({
    baseURL: API_BASE_URL,
});

export const registerUser = async (userData: { email: string; fistName: string; lastName: string }) => {
    try {
        const response = await api.post(authRoutes.SIGNUP, userData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (error) {
        console.error("Registration failed:", error);
        throw error;
    }
};

export const ContactUs = async (contactData: { email: string; message: string }) => {
    try {
        const response = await api.post(authRoutes.CONTACT_US, contactData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (error) {
        console.error("Registration failed:", error);
        throw error;
    }
};

export const loginUser = async (userData: { email: string; password: string; }) => {
    try {
        const response = await api.post(authRoutes.LOGIN, userData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (error) {
        console.error("Login failed:", error);
        throw error;
    }
};
export const forgetPassword = async (email: string) => {
    try {
        const response = await api.get(`${authRoutes.LOGIN}?email=${email}`);
        return response;
    } catch (error) {
        console.error("forget request failed:", error);
        throw error;
    }
};